module.exports = __webpack_public_path__ + "img/SDAAbadgeNoBackground.1aa4f83f.png";